module.exports = __webpack_public_path__ + "img/redis.70f6208f.svg";